import { useQuery } from '@tanstack/react-query';
import {
  getSites, type SiteFilters 
} from '../api';

export function useSites(filters?: SiteFilters) {
  return useQuery({
    queryKey: ['sites', filters],
    queryFn: () => getSites(filters),
  });
}
